<template>
    <div class="container-fluid">
      <bounce-loader :loading="loading"></bounce-loader>
      <div class="row" v-if="data">
        <div class="col-xs-12">
          <h1 id="proy-code" class="pull-left">
            {{ data.cta_text }}
            <a :href="data.cta_link_or_iframe_src" target="_blank">
              <i class="fa fa-external-link-alt"></i>
            </a>
          </h1>
        </div>
      </div>
      <div class="row" v-if="error">
        <div class="col-md-6">
          <h1 id="proy-code" class="pull-left">{{ codigo_proyecto }}</h1>
        </div>        
        <div class="col-xs-12 text-center">
          {{ error }}
        </div>
      </div>      
    </div>
</template>
<script>
import api from '../../../api'
// import { EventBus } from '../../core/event-bus.js'
export default {
  name: 'ProyectoLink',
  props: ['codigo_proyecto'],
  data () {
    return {
      data: null,
      error: null,
      loading: true
    }
  },
  mounted () {
    let vm = this
    api.getProyectoLink(this.codigo_proyecto, 'link').then(data => {
      vm.data = data
      vm.loading = false
    }, error => {
      vm.error = error.message
      vm.loading = false
    })
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/proyectos/Link.vue